import PasswordReset from "@/models/PasswordReset";
import router from "../../routes";

export default {
    namespaced: true,

    state: () => ({
        
    }),

    mutations: {
        
    },

    actions: {
        async sendVerificationSMS({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                let { data } = await PasswordReset.sendVerificationSMS(body);
                
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "A verification SMS has been sent to this phone number."
                    },

                    { root: true }
                );
                console.log(data, 'data')
                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message
                    },

                    { root: true }
                );
                
                console.log(ex.response?.data, 'data')
                return ex.response?.data
            }
        },

        async updatePassword({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                await PasswordReset.updatePassword(body);
                
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "Your password has been reset. Thank you."
                    },

                    { root: true }
                );
                router.push("/en/sign-in")
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
    }
};
